import { Injectable, inject } from '@angular/core';

import { ApiService } from '@frontend/sports/common/api-utils';
import { usePreloaderData } from '@frontend/sports/common/core/utils/preloaded-data';
import { SportsProductService } from '@frontend/sports/host-app/sports-product/feature/sports-product-service';
import { BehaviorSubject, Observable, of, switchMap } from 'rxjs';

import { SiteMapResponse, SitemapModel } from './sitemap.models';

@Injectable({
    providedIn: 'root',
})
export class SitemapService {
    private readonly api = inject(ApiService);
    private readonly sportsProductService = inject(SportsProductService);

    private readonly _sitemapSubject$ = new BehaviorSubject<SitemapModel>({ items: [] });
    private readonly _sitemap$ = this.sportsProductService.isSportsProductActive$.pipe(
        switchMap((isSportsActive) => {
            return isSportsActive ? this._sitemapSubject$.asObservable() : of({ items: [] });
        }),
    );

    get sitemap$(): Observable<SitemapModel> {
        return this._sitemap$;
    }

    @usePreloaderData({
        preloader: (<any>window).MS2JS?.SiteMapLoader,
    })
    getSiteMapConfiguration(): Observable<SiteMapResponse> {
        return this.api.get<SiteMapResponse>('sitemap');
    }

    setSitemap(sitemap: SitemapModel): void {
        this._sitemapSubject$.next(sitemap);
    }
}
